import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CopyButton from './CopyButton';

class MagazineCreateButton extends PureComponent {
  render() {
    const { url, disabled } = this.props;

    return (
      <div className={classnames('result-output', { 'has-url': url })}>
        <div className="magazine-url-wrap">
          {url && <input className="magazine-url-input" value={url} readOnly />}
        </div>
        <div className="button-wrap">
          {url && <CopyButton text={url} />}
          {url && (
            <a className="btn btn-primary" href={url} target="_blank">
              Open
            </a>
          )}
          <button
            color="primary"
            className="btn btn-primary create-magazine-button"
            type="submit"
            disabled={disabled}
          >
            {url && 're-'}
            create
          </button>
        </div>
      </div>
    );
  }
}

MagazineCreateButton.propTypes = {
  url: PropTypes.string,
  disabled: PropTypes.bool
};

export default MagazineCreateButton;



// WEBPACK FOOTER //
// ./src/components/formFields/MagazineCreateButton.js